<div class="ng-otp-input-wrapper wrapper {{config.containerClass}}" id="c_{{componentKey}}" *ngIf="otpForm?.controls"
  [ngStyle]="config.containerStyles" tabindex="0" 
  (focusin)="onFocusIn()" 
  (focusout)="onFocusOut()">
  <div class="n-o-c">
    <ng-container *ngFor="let item of controlKeys;let i=index;let last=last">
      <input (paste)="handlePaste($event)" [pattern]="config.allowNumbersOnly ? '\\d*' : ''" 
      [type]="inputType"  [placeholder]="config?.placeholder || ''"
      [attr.inputmode]="config.allowNumbersOnly ? 'numeric' : (config.inputMode ||'text')"
      [ngStyle]="config.inputStyles" 
      class="otp-input {{config.inputClass}}" autocomplete="one-time-code" 
      [formControl]="otpForm.controls[item]" #inp [id]="getBoxId(i)" 
      (keyup)="onKeyUp($event,i)" (input)="onInput($event,i)" (keydown)="onKeyDown($event,i)" [ngClass]="{'error-input': (config?.showError && formControl?.invalid && (formControl?.dirty || formControl?.touched))}">
      <span *ngIf="config.separator && !last">
        {{config.separator}}
      </span>
    </ng-container>
  </div>  
</div>